import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const DegreeForm = ({ degreeId, initialData, onSuccess }) => {
     const baseUrl = process.env.REACT_APP_BASE_URL;
     const [degreeName, setDegreeName] = useState('');
     const [loading, setLoading] = useState(false);
     const [error, setError] = useState('');
     const navigate = useNavigate();

     useEffect(() => {
          if (initialData && initialData.degrees) {
               setDegreeName(initialData.degrees);
          }
     }, [initialData]);

     const handleSubmit = async (e) => {
          e.preventDefault();
          if (!degreeName.trim()) {
               setError('Degree name is required');
               return;
          }
          setLoading(true);
          setError('');
          try {
               let url = '';
               let method = 'POST';
               let body = {};
               const token = localStorage.getItem('token');
               if (degreeId) {
                    url = `${baseUrl}/updateDegreeById/${degreeId}`;
                    body = { degrees: degreeName };
               } else {
                    url = `${baseUrl}/createDegree`;
                    body = { degrees: degreeName };
               }
               const response = await fetch(url, {
                    method,
                    headers: {
                         'Authorization': `Bearer ${token}`,
                         'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(body),
               });
               const data = await response.json();
               if (data.status) {
                    alert(degreeId ? 'Degree updated successfully' : 'Degree created successfully');
                    if (onSuccess) onSuccess();
                    navigate('/degrees');
               } else {
                    setError(data.message || `Failed to ${degreeId ? 'update' : 'create'} Degree`);
               }
          } catch (err) {
               setError('Error connecting to server');
          } finally {
               setLoading(false);
          }
     };

     const handleCloseModal = () => {
          navigate('/degrees');
     };

     return (
          <form className="general-info-form" onSubmit={handleSubmit}>
               <div className="form-grid">
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control"
                              id="degreeName"
                              placeholder=" "
                              autoComplete="off"
                              value={degreeName}
                              onChange={(e) => setDegreeName(e.target.value)}
                              disabled={loading}
                         />
                         <label htmlFor="degreeName">Degree Name</label>
                    </div>
               </div>
               <div style={{ marginTop: '15px', display: 'flex', gap: '10px' }}>
                    {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}
                    <button type="submit" className="btn btn-primary" disabled={loading}>
                         {loading ? 'Saving...' : 'Save'}
                    </button>
                    <button type="button" className="btn btn-secondary" onClick={handleCloseModal} disabled={loading}>
                         Cancel
                    </button>
               </div>
          </form>
     );
};

export default DegreeForm;